import { Card } from '../../ui/card';
import { Badge } from '../../ui/badge';

const AuditTab = ({ bank }) => {
  return (
    <Card className="p-4">
      <h3 className="font-semibold mb-4">Audit Log</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left p-2">Date/Time</th>
              <th className="text-left p-2">Action</th>
              <th className="text-left p-2">Field</th>
              <th className="text-left p-2">Old Value</th>
              <th className="text-left p-2">New Value</th>
              <th className="text-left p-2">Notes</th>
            </tr>
          </thead>
          <tbody>
            {bank.audit?.length > 0 ? bank.audit.map((entry, idx) => (
              <tr key={`${entry.ts}-${entry.field}-${idx}`} className="border-b hover:bg-slate-50">
                <td className="p-2">{entry.ts}</td>
                <td className="p-2"><Badge variant="outline">{entry.action}</Badge></td>
                <td className="p-2 font-medium">{entry.field}</td>
                <td className="p-2 text-slate-600">{entry.oldVal || '-'}</td>
                <td className="p-2 text-slate-600">{entry.newVal || '-'}</td>
                <td className="p-2 text-slate-600">{entry.notes || '-'}</td>
              </tr>
            )) : (
              <tr><td colSpan="6" className="p-8 text-center text-slate-500">No audit entries</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default AuditTab;
